import {AnimationFactory} from "../types";

export const createCometExplosionAnimation: AnimationFactory = ({
                                                                    ctx,
                                                                    canvas,
                                                                    startX,
                                                                    startY,
                                                                    endX,
                                                                    endY,
                                                                    startTime,
                                                                    scale
                                                                }) => {
    const duration = 600;
    const explosionDuration = 400;
    const particlesCount = 30;


    const SCALE = scale;

    type Particle = {
        x: number;
        y: number;
        vx: number;
        vy: number;
        radius: number;
        color: string;
    };

    let particles: Particle[] = [];
    const angle = Math.atan2(endY - startY, endX - startX);

    const createExplosion = (x: number, y: number) => {
        particles = [];
        for (let i = 0; i < particlesCount; i++) {
            const ang = Math.random() * Math.PI * 2;
            const speed = (1 + Math.random() * 3) * SCALE; // трохи більший розліт
            particles.push({
                x,
                y,
                vx: Math.cos(ang) * speed,
                vy: Math.sin(ang) * speed,
                radius: (3 + Math.random() * 4) * SCALE, // більші частинки
                color: `rgba(${200 + Math.random() * 55}, ${
                    50 + Math.random() * 100
                }, 0, 1)`,
            });
        }
    };

    return (now: number) => {
        const elapsed = now - startTime;
        const flightProgress = Math.min(elapsed / duration, 1);

        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (flightProgress < 1) {
            const x = startX + (endX - startX) * flightProgress;
            const y = startY + (endY - startY) * flightProgress;

            // 👉 збільшуємо хвіст
            const tailLength = (40 + flightProgress * 80) * SCALE;
            const tailEndX = x - Math.cos(angle) * tailLength;
            const tailEndY = y - Math.sin(angle) * tailLength;

            const tailGradient = ctx.createLinearGradient(
                x,
                y,
                tailEndX,
                tailEndY
            );
            tailGradient.addColorStop(0, "rgba(255, 255, 255, 1)");
            tailGradient.addColorStop(0.3, "rgba(255, 200, 50, 0.8)");
            tailGradient.addColorStop(1, "rgba(255, 0, 0, 0)");

            ctx.strokeStyle = tailGradient;
            ctx.lineWidth = 4 * SCALE; // товстіший хвіст
            ctx.beginPath();
            ctx.moveTo(tailEndX, tailEndY);
            ctx.lineTo(x, y);
            ctx.stroke();

            // 👉 збільшуємо ядро
            const coreRadius = (5 + flightProgress * 3) * SCALE;
            const coreGradient = ctx.createRadialGradient(
                x,
                y,
                0,
                x,
                y,
                coreRadius + 6 * SCALE
            );
            coreGradient.addColorStop(0, "rgba(255, 255, 255, 1)");
            coreGradient.addColorStop(0.4, "rgba(255, 220, 150, 1)");
            coreGradient.addColorStop(1, "rgba(255, 100, 0, 0.2)");

            ctx.fillStyle = coreGradient;
            ctx.beginPath();
            ctx.arc(x, y, coreRadius + 6 * SCALE, 0, Math.PI * 2);
            ctx.fill();

            return true;
        }

        const explosionElapsed = elapsed - duration;
        const explosionProgress = Math.min(
            explosionElapsed / explosionDuration,
            1
        );

        if (particles.length === 0) {
            createExplosion(endX, endY);
        }

        for (const p of particles) {
            const t = explosionProgress;
            const friction = 0.98;

            p.x += p.vx * (1 - t);
            p.y += p.vy * (1 - t);

            p.vx *= friction;
            p.vy *= friction + 0.01;

            const alpha = 1 - t;
            ctx.fillStyle = p.color.replace(/, *1\)$/, `, ${alpha})`);

            ctx.beginPath();
            // 👉 радіус теж через SCALE
            ctx.arc(p.x, p.y, p.radius * (1 - t), 0, Math.PI * 2);
            ctx.fill();
        }

        return explosionProgress < 1;
    };
};